module.exports = __webpack_public_path__ + "static/page-1-afa706948b1acb1ecc04d0a8b1b9c9de.jpg";